import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgPackageFill = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M15.7 3.85 6.512 8.425 2.825 6.587 12.025 2 15.7 3.85ZM21.15 6.574 12 11.162 8.762 9.549l9.175-4.587 3.213 1.612ZM11.25 12.463l-3.688-1.837v5.437l-2-.987v-5.45L2 7.85V17l9.262 4.625-.012-9.163Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m12.762 21.625-.012-9.162L22 7.825V17l-9.238 4.625Zm3.476-5.1 3-1.5V12.75l-3 1.5v2.275Z", fill: "currentColor" }))); };

export { SvgPackageFill as default };
